export const CHANGELOG_TAB_ITEMS = [
  { value: "all", label: "All" },
  { value: "features", label: "Features" },
  { value: "fixes", label: "Fixes" },
  { value: "breaking", label: "Breaking" },
] as const;

export const CHANGELOG_PERIOD_OPTIONS = [
  { value: "all", label: "All time" },
  { value: "last-24-hours", label: "Last 24 hours" },
  { value: "last-7-days", label: "Last 7 days" },
  { value: "last-28-days", label: "Last 28 days" },
] as const;

export const CHANGELOG_TRACK_OPTIONS = [
  { value: "all", label: "All releases" },
  { value: "stable", label: "Stable" },
  { value: "beta", label: "Beta" },
] as const;

export type ChangelogToolbarTab = (typeof CHANGELOG_TAB_ITEMS)[number]["value"];
export type ChangelogPeriodFilter = (typeof CHANGELOG_PERIOD_OPTIONS)[number]["value"];
export type ChangelogTrackFilter = (typeof CHANGELOG_TRACK_OPTIONS)[number]["value"];
